module.exports = __webpack_public_path__ + "static/media/award.fc5f11c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/award.jpg
// module id = 935
// module chunks = 0